// NPM
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';

// ANT COMPONENT
import { Collapse } from 'antd';

// STYLE
import '../corporate-order/corporate-order.scss';
import './faq.scss';

// INITIALISE VARIABLE
const { Panel } = Collapse;

const FaqPage = () => {
  // INITIALISE VARIABLE
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Helmet>
        <title>
          {t('pageTitle.faq')}
        </title>
      </Helmet>

      <div className="faq-page">
        <div className="faq-page--main">
          <div className="faq-page--container">
            <div className="faq-page--content sm:px-15">

              <div className="faq-page--content-title">
                {t('txt.faqTitle')}
              </div>

              <Collapse>
                <Panel header={t('label.firstFaq')} key="1">
                  <p dangerouslySetInnerHTML={{ __html: t('txt.firstFaq') }}/>
                </Panel>
                <Panel header={t('label.secondFaq')} key="2">
                  <p dangerouslySetInnerHTML={{ __html: t('txt.secondFaq') }}/>
                </Panel>
                <Panel header={t('label.thirdFaq')} key="3">
                  <p dangerouslySetInnerHTML={{ __html: t('txt.thirdFaq') }}/>
                </Panel>
                <Panel header={t('label.fourthFaq')} key="4">
                  <p dangerouslySetInnerHTML={{ __html: t('txt.fourthFaq') }}/>
                </Panel>
                {/* <Panel header={t('label.fifthFaq')} key="5">
                  <p dangerouslySetInnerHTML={{ __html: t('txt.fifthFaq') }}/>
                </Panel> */}
                <Panel header={t('label.sixthFaq')} key="6">
                  <p dangerouslySetInnerHTML={{ __html: t('txt.sixthFaq') }}/>
                </Panel>
                <Panel header={t('label.seventhFaq')} key="7">
                  <p dangerouslySetInnerHTML={{ __html: t('txt.seventhFaq') }}/>
                </Panel>
                <Panel header={t('label.eightFaq')} key="8">
                  <p dangerouslySetInnerHTML={{ __html: t('txt.eightFaq') }}/>
                </Panel>
                <Panel header={t('label.nineFaq')} key="9">
                  <p dangerouslySetInnerHTML={{ __html: t('txt.nineFaq') }}/>
                </Panel>
                <Panel header={t('label.tenthFaq')} key="10">
                  <p dangerouslySetInnerHTML={{ __html: t('txt.tenthFaq') }}/>
                </Panel>
                <Panel header={t('label.eleventhFaq')} key="11">
                  <p dangerouslySetInnerHTML={{ __html: t('txt.eleventhFaq') }}/>
                </Panel>
                 <Panel header={t('label.twelfthFaq')} key="12">
                  <p dangerouslySetInnerHTML={{ __html: t('txt.twelfthFaq') }}/>
                </Panel>
                <Panel header={t('label.thirteenthFaq')} key="13">
                  <p dangerouslySetInnerHTML={{ __html: t('txt.thirteenthFaq') }}/>
                </Panel>
                <Panel header={t('label.fourteenthFaq')} key="14">
                  <p dangerouslySetInnerHTML={{ __html: t('txt.fourteenthFaq') }}/>
                </Panel>
              </Collapse>

              <div className="mt-50" dangerouslySetInnerHTML={{ __html: t('txt.linkToSupport') }}/>
            </div>
            <div className="faq-page--bot"></div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default FaqPage;